import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Phone, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-muted/30 overflow-hidden" data-id="element-157">
      <div className="container mx-auto px-4 py-16 md:py-24 lg:py-32" data-id="element-158">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-159">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} className="flex flex-col gap-6" data-id="element-160">
            <div className="inline-flex items-center rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-sm font-medium text-primary w-fit" data-id="element-161">
              St. Augustine's Premier Neuropathy Clinic
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground" data-id="element-162">
              Hands or Feet Tingling, Burning, or Going Numb?
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-[600px]" data-id="element-163">
              Discover a drug-free, non-surgical path to lasting relief. Regain
              your balance, sleep through the night, and get back to the
              activities you love.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-164">
              <Button size="lg" className="text-base h-12 px-8" asChild data-id="element-165">
                <a href="#contact" data-id="element-166">Schedule Your Free Consultation</a>
              </Button>
              <Button size="lg" variant="outline" className="text-base h-12 px-8 gap-2" asChild data-id="element-167">
                <a href="tel:9041234567" data-id="element-168">
                  <Phone className="w-4 h-4" data-id="element-169" />
                  Call (904) 123-4567
                </a>
              </Button>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 pt-6 mt-2 border-t" data-id="element-170">
              <div className="flex items-center gap-2 text-sm font-medium" data-id="element-171">
                <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-172" />
                Drug-Free Approach
              </div>
              <div className="flex items-center gap-2 text-sm font-medium" data-id="element-173">
                <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-174" />
                Non-Surgical
              </div>
              <div className="flex items-center gap-2 text-sm font-medium" data-id="element-175">
                <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-176" />
                FDA-Cleared Tech
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="relative" data-id="element-177">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-178">
              <img src="https://cdn.magicpatterns.com/uploads/ek2mN7Vb7xcwBodBHyZACC/myofascial_theraphy_photo_2.jpg" alt="A patient relaxing during gentle myofascial therapy at the clinic" className="object-cover w-full h-full" data-id="element-179" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-180" />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-background rounded-xl p-4 shadow-xl border flex items-center gap-4" data-id="element-181">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-182">
                <CheckCircle2 className="w-6 h-6 text-primary" data-id="element-183" />
              </div>
              <div data-id="element-184">
                <p className="font-bold text-foreground" data-id="element-185">Free Consultation</p>
                <p className="text-sm text-muted-foreground" data-id="element-186">
                  Limited time offer
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}